<template>
  <div class="neo-hero">
    <img class="neo-hero__bg" :src="getWebsiteImage('neo-bg.png')" alt="BG" />
    <div class="neo-container">
      <neo-nav :show-only-routes="true" />
      <div class="neo-other--header">
        <div class="title" data-aos="fade-up">
          <h1>Privacy Policy</h1>
        </div>
      </div>
    </div>
  </div>
  <div class="neo-container">
    <div class="neo-terms">
      <section>
        <h5>Objective</h5>
        <p>
          Neo FS Limited in the UK and Neo LLC in the US, operating under our
          app name 99Fi, are dedicated to upholding the trust and privacy of our
          customers. This policy clarifies how we, through 99Fi, gather, share,
          and manage customer information across both entities, ensuring a
          consistent and secure approach to data handling and privacy. We are
          steadfast in protecting our customers' personal financial data,
          whether they are interacting with us via 99Fi in the United Kingdom or
          the United States. Our commitment aligns with our internal policies
          and adheres to the applicable laws in both jurisdictions. Our goal is
          to maintain the highest standards of data protection and privacy for
          all our customers using 99Fi, irrespective of their geographic
          location.
        </p>
      </section>
      <section>
        <h5>Definitions</h5>
        <ul>
          <li>“99Fi”, "We," "our," and "us" refer to Neo.</li>
          <li>"You" and "your" refer to Neo’s customers.</li>
          <li>
            "Nonpublic personal information" is the information we collect in
            the context of providing you with a financial product or service. It
            excludes publicly available information. In this document,
            "information" will refer to nonpublic personal information as
            defined here.
          </li>
          <li>
            "Affiliate" is any entity that Neo owns or controls, or that owns or
            controls Neo, or is under common control with Neo. Affiliates can
            access your information for their business functions but are
            restricted from using it for other purposes.
          </li>
          <li>
            "Nonaffiliated third party" is any entity not employed by or
            affiliated with Neo.
          </li>
          <li>
            "Opt-out" is your right to prevent certain sharing or use of your
            information, as further explained below.
          </li>
        </ul>
      </section>
      <section>
        <h5>Collection and Use of Information:</h5>
        <p>
          To conduct our business, process transactions, and deliver our
          services, we collect the following types of nonpublic personal
          information:
        </p>
        <ul>
          <li>
            Information you provide during applications or communications (e.g.,
            name, Social Security number, Other Government Identification
            number, contact details, and date of birth).
          </li>
          <li>
            Transaction details with us, our partners, or others (e.g., account
            balances, transaction history, and usage information).
          </li>
          <li>
            Information from third-party sources for application validation and
            decision-making (e.g., credit reports).
          </li>
        </ul>
      </section>
      <section>
        <h5>Disclosure of Information:</h5>
        <p>
          We may share the information we collect, as described above, with
          affiliates and service providers for operational purposes, customer
          service, and account management. We may also disclose information for
          legal and security purposes, with your consent, or as permitted by
          law.
        </p>
      </section>
      <section>
        <h5>Other Disclosures:</h5>
        <p>
          We may share contact information with non-affiliated entities, such as
          financial service providers or marketers, for offers of interest,
          unless you opt out.
        </p>
      </section>
      <section>
        <h5>Use of Agents and Service Providers:</h5>
        <p>
          We employ external companies for tasks like shipping, billing, and
          analytics. These entities are prohibited from misusing your
          information and are bound by our privacy standards.
        </p>
      </section>
      <section>
        <h5>Opt-Out Options:</h5>
        <p>
          You have the right to opt out of certain marketing practices or the
          sharing of your information with non-affiliated third parties. Opt out
          by contacting us at:
        </p>
        <ul>
          <li>
            Email: <a href="mailto:support@withneo.co">support@withneo.co</a>
          </li>
          <li>
            Mail: Neo, International House, 45-55 Commercial Street, London, E1
            6BD
          </li>
        </ul>
      </section>
      <section>
        <h5>Special Notice for [State/Region-Specific] Residents:</h5>
        <p>
          Residents of certain jurisdictions have specific rights under local
          laws, including additional opt-out rights and restrictions on
          information shari
        </p>
      </section>
      <section>
        <h5>Communications from Neo:</h5>
        <p>
          You can choose to receive or decline marketing communications. We will
          also send necessary service-related announcements.
        </p>
      </section>
      <section>
        <h5>Information Security:</h5>
        <p>
          We use rigorous security measures to safeguard your nonpublic personal
          information, including restricted access, comprehensive employee
          training and security mesure:
        </p>
        <ul>
          <li>
            1. Physical Safeguards: We maintain secure physical barriers and
            control protocols to protect our physical premises and data storage
            locations.
          </li>

          <li>
            2. Electronic Safeguards: Our electronic security measures include
            advanced encryption technologies and firewall protections. When you
            enter sensitive information, such as your Social Security number, on
            our registration or order forms, we protect it using secure socket
            layer (SSL) technology. This ensures that your data is encrypted and
            securely transmitted over the internet.
          </li>

          <li>
            3. Procedural Safeguards: Our internal procedures are designed to
            comply with federal standards, ensuring that only authorized
            personnel have access to your personal information. Regular training
            and audits are conducted to ensure these procedures are followed
            diligently.
          </li>
        </ul>
      </section>
      <section>
        <h5>Categories of Personal Information NEO Collects</h5>
        <p>
          NEO collects personal information primarily to provide financial
          products and services. This information is crucial for administering
          our services, understanding customer needs, and offering relevant
          products. The categories and examples of personal information we
          collect include:
        </p>
        <ul>
          <li>
            1. Identifiers: This includes your name, address, telephone number,
            email address, and other similar identifiers.
          </li>

          <li>
            2. Contact and Financial Information: Details provided during credit
            card applications, transactions, and interactions with our website
            or mobile applications, as well as calls to our customer service.
          </li>

          <li>
            3. Commercial Information: Information regarding your transactions
            or purchases with NEO.
          </li>

          <li>
            4. Internet or Other Electronic Network Activity: This covers your
            interactions with our website, applications, or advertisements.
          </li>

          <li>
            5. Geolocation Data: We may collect data about the location of your
            device.
          </li>

          <li>
            6. Inferences: Based on the collected information, we may draw
            inferences about your preferences and characteristics to better
            tailor our services to your needs.
          </li>
        </ul>
      </section>
      <section>
        <h5>Sources of Personal Information</h5>
        <p>We gather personal information from various sources:</p>
        <ul>
          <li>
            1. Directly from You: Through interactions such as credit card
            applications, website or app usage, and customer service
            communications.
          </li>

          <li>
            2. Business Partners: Information obtained through partnerships and
            collaborations.
          </li>

          <li>
            3. Service Providers: Data from providers that assist us in offering
            and improving our services, like software and marketing companies,
            data analytics, and fraud prevention services.
          </li>

          <li>
            4. Third Parties Authorized by You: Information shared by payment
            processors, credit management programs, and additional cardholders
            connected to your account, as directed by you.
          </li>
        </ul>
      </section>
      <section>
        <h5>Purposes for Using Personal Information</h5>
        <p>
          NEO uses the collected information for multiple business-related
          purposes:
        </p>
        <ul>
          <li>
            1. Service Provision and Maintenance: To provide, maintain, and
            improve our financial products and services.
          </li>

          <li>
            2. Identity Verification and Fraud Prevention: Ensuring the security
            and legitimacy of transactions and services.
          </li>

          <li>
            3. Advertising and Marketing: To inform you about relevant products
            and services.
          </li>

          <li>
            4. Research and Data Analysis: For understanding customer trends and
            improving our offerings.
          </li>

          <li>
            5. Legal and Business Operations: Complying with laws, responding to
            legal requirements, managing disputes, and maintaining business
            operations.
          </li>

          <li>
            6. Quality and Safety Assurance: Ensuring the quality and safety of
            our services and implementing necessary improvements.
          </li>
        </ul>
      </section>
      <section>
        <h5>Disclosure of Personal Information to Third Parties</h5>
        <p>
          Where applicable the gathered personal information will be disclosed
          for business purposes to:
        </p>
        <ul>
          <li>
            1. Service Providers: Such as software providers, marketing
            companies, communication services, fraud prevention services, and
            data analytics providers.
          </li>

          <li>
            2. Business Partners: Including entities involved in card
            partnerships.
          </li>

          <li>
            3. Authorized Third Parties: This includes entities like payment
            processors and credit management programs, as authorized by you.
          </li>
        </ul>
        <p>
          NEO is committed to responsibly handling and protecting your personal
          information while providing you with excellent financial services and
          support.
        </p>

        <p>
          We are committed to continually updating and refining our security
          practices to protect against evolving threats and to ensure the safety
          and confidentiality of your personal information.
        </p>
      </section>
      <section>
        <h5>External Links:</h5>
        <p>
          Our website may contain links to third-party sites. We are not
          responsible for the privacy practices of these sites and encourage you
          to read their privacy policies.
        </p>
      </section>
      <section>
        <h5>NEO Cookie Policy</h5>
        <p>
          NEO and our third-party partners utilize various technologies,
          including cookies and pixel tags, to collect information for enhancing
          your experience and providing personalized services and
          advertisements.
        </p>
      </section>
      <section>
        <h5>Technologies We Use</h5>
        <ul>
          <li>
            1. Cookies: Cookies are small text files stored in your browser to
            remember your preferences and improve your experience on our site.
          </li>

          <li>
            2. Pixel Tags/Web Beacons: These are small pieces of code on our
            services that gather data about your interaction, like page visits
            or ad clicks. They may also be used in emails to track engagement.
          </li>
        </ul>
        <p>Our use of these technologies is categorized as follows:</p>
        <ul>
          <li>Operationally Necessary</li>
          <li>Performance Related</li>
          <li>Functionality Related</li>
          <li>Advertising or Targeting Related</li>
        </ul>
      </section>
      <section>
        <h5>Advertising Technologies</h5>
        <p>
          We may use technologies like Facebook Connect for advertising
          purposes. For details on Facebook’s data use, visit their Data Policy.
          To opt out of Facebook's data use, adjust your settings on your
          Facebook account.
        </p>
      </section>
      <section>
        <h5>Analytics Technologies</h5>
        <p>
          We employ analytics tools such as Google Analytics. Visit Google
          Analytics’ Privacy Policy for more information and instructions to opt
          out of their data use.
        </p>
      </section>
      <section>
        <h5>Your Choices Regarding Technologies</h5>
        <p>
          You can control the use of these technologies through your browser or
          device settings. Note that restricting these technologies may affect
          the functionality of our services. On mobile applications,
          cookie-based opt-outs may not work, but you can opt out of
          personalized ads by adjusting your mobile device settings.
        </p>
      </section>
      <section>
        <h5>Opting Out of Targeted Advertising</h5>
        <p>
          You can opt out of targeted advertising through industry websites like
          the Network Advertising Initiative and the Digital Advertising
          Alliance, which provide information on consumer choice and privacy in
          digital advertising.
        </p>
        <p>
          NEO is committed to respecting your choices and providing transparency
          about the data we collect.
        </p>
      </section>
      <section>
        <h5>State/Region-Specific Rights:</h5>
        <p>
          We adhere to state privacy laws, providing additional protections or
          rights where applicable.
        </p>
      </section>
      <section>
        <h5>Accuracy of Information:</h5>
        <p>
          We ensure the accuracy of the personal information we collect and
          provide ways for you to update your information.
        </p>
      </section>
      <section>
        <h5>Policy Changes:</h5>
        <p>
          We may modify this policy and will notify you of significant changes
          as legally required.
        </p>
      </section>
      <section>
        <h5>Annual Notice:</h5>
        <p>
          We will provide an annual notice detailing our privacy policies and
          practices as part of our ongoing customer relationship.
        </p>
      </section>
      <section>
        <h5>Questions</h5>
        <p>
          If you have queries about this Privacy Policy, please contact us at
          the provided email or postal addresses.
        </p>
      </section>
      <section>
        <h5>Penalties for Non-Compliance:</h5>
        <p>
          Non-compliance with our policies may result in disciplinary action.
          Concerns about policy compliance should be directed to our Information
          Security Officer and Human Resources.
        </p>
      </section>
    </div>
  </div>
  <neo-footer />
</template>

<script>
import NeoNav from "@/components/Website/NeoNav";
import NeoFooter from "@/components/Website/NeoFooter";
export default {
  name: "NeoPrivacyPolicy",
  components: { NeoFooter, NeoNav },
};
</script>

<style lang="scss" scoped>
.neo-hero {
  height: 100%;
  padding-bottom: 80px;
}

.neo-other--header {
  width: 80%;
  margin: 0 auto;
  text-align: center;

  .title {
    margin: 50px 0 10px;
  }

  .description {
    p {
      margin: 0 auto 10px;
    }
  }
}

.neo-terms {
  width: 75%;
  margin: 0 auto;
  padding: 50px 0;

  h5 {
    margin-bottom: 20px;
  }

  section {
    margin-bottom: 30px;

    h6 {
      font-size: 1.25rem;
      margin-bottom: 15px;
    }
    p {
      font-size: 16px;
      color: #121212;
      opacity: 1;
      margin-bottom: 15px;
    }

    > ul {
      list-style-type: none;
      margin: 0 0 15px;
      padding: 0;

      li {
        color: #121212 !important;
        line-height: 1.5;
          font-size: 16px;

        &:not(:last-child) {
          margin-bottom: 15px;
        }
      }

      ul {
        margin: 15px 0;

        li:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .neo-other--header {
    .description p {
      font-size: 1rem;
    }
  }

  .neo-terms {
    width: 90%;
  }
}

@media (max-width: 600px) {
  .neo-hero {
    height: 100%;
    padding-bottom: 20px;
  }

  .neo-other--header {
    width: 100%;
    .title {
      margin: 20px 0;

      h1 {
        font-size: 2rem;
      }
    }

    .description p {
      text-align: justify;
    }
  }

  .neo-terms {
    width: 100%;
    padding: 30px 0;
  }
}
</style>
